import { RouteObject } from 'react-router-dom';
import GraphQlInspector from '../pages/Developer/GraphQlInspector';
import GraphQlVisualiser from '../pages/Developer/GraphQlVisualiser';

export const devRoutes: RouteObject[] = [
  { path: '/developer/graphql-visualiser', element: <GraphQlVisualiser /> },
  { path: '/developer/graphql-inspector', element: <GraphQlInspector /> },
];
